export default __webpack_public_path__ + "static/media/ai04.d926a666.png";